import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { IconBackground } from 'common/components';
import { InfoYellow } from 'common/svg';
import { EColor } from 'common/const';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const DeleteUserAssigneeModal: FC<IComponentProps> = ({ open, loading, onCancel, onSubmit }) => {
  const handleCancel = () => {
    if (loading) {
      return;
    }

    onCancel();
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={440}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      // @ts-ignore
      styles={{ mask: { zIndex: 1002 }, wrapper: { zIndex: 1003 } }}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          Отмена
        </Button>,
        <Button key="submit" className="button-sm primary" loading={loading} onClick={onSubmit}>
          Да, удалить
        </Button>,
      ]}
    >
      <div className="mb-7">
        <IconBackground content={<InfoYellow className="icon-info-yellow" />} color={EColor.PaleYellow} />
      </div>

      <div className="mb-4 ff-medium fs-m">Удаление добавленного сотрудника</div>

      <div className="mb-6 ff-regular fs-s color-dark-grey">Вы уверены, что хотите удалить пользователя?</div>
    </Modal>
  );
};
